<template>
  <ym-loadmore class="page page-training-camp"
               v-model="loading"
               :finished="allLoad"
               @load="fetchData"
  >
    <list :list="list"
          empty-string="暂无课程"
          :show-empty="allLoad"
    />
  </ym-loadmore>
</template>

<script>
  import { Loadmore } from '@ymba/ym-ui';
  import List from '@/components/ProductList/List';
  import { getTrainingList } from '@/services/training';
  import { LIMIT } from '@/utils/constant';

  export default {
    name: 'TrainingList',
    metaInfo() {
      return {
        title: this.render.pageTitle,
      };
    },
    components: {
      'ym-loadmore': Loadmore,
      List,
    },
    data() {
      return {
        start: 0,
        list: [],
        allLoad: false,
        loading: false,
        render: {
          pageTitle: '训练营',
        },
      };
    },
    methods: {
      async fetchData() {
        if (this.allLoad) return;
        this.loading = true;


        const { start } = this;
        const params = {
          start,
          limit: LIMIT,
        };
        const data = await getTrainingList(params);

        if (data.list.length === 0) {
          this.allLoad = true;
          this.loading = false;
          return;
        }

        this.start = data.start;
        this.render = data.render;
        this.list = [...this.list, ...data.list];

        this.loading = false;
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-training-camp {
    background: @color-white;
  }

</style>
